module.exports = __webpack_public_path__ + "img/1.9d1b3bb7.png";